import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";

import {Button} from "reactstrap";
import ReactTable from "react-table";
import moment from "moment";
import {confirmAlert} from "react-confirm-alert";
import {Link} from "react-router-dom";
import {Card, CardContent, Tooltip} from "@material-ui/core";
import {Objects} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";
import CollectionOverride from "components/CollectionOverride";



export default class DispositionPendingsFirearms extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Dispositions_Pendings._name, API.RequestType.READ_ALL);
		super(props, model);
		this.limit = 10;
		this.state.limit = 10;
		this.state = {
			...this.state,
			id: null,
			binary_id: null,
			object: null,
			sendToKioskModalOpen: false,
			showDLmodal: false
		};
	}

	handleDelete = (pkey, binary_id) => () => {
		confirmAlert({
			title: 'Confirm Delete',
			message: 'Are you sure you want to delete this Pending 4473?',
			buttons: [
				{
					label: 'Yes',
					color: 'danger',
					onClick: async () => {
						this.model.object.pkey = pkey;
						this.model.object.binary_id = binary_id;
						try {
							await this.model.submit(null, API.RequestType.DELETE);
							this.reloadTable();
						} catch (error) {
						}
						this.model.object.pkey = '';
						this.model.object.binary_id = '';
						this.props.reloadPage();
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});

	};

	handleToggleSendToKioskModal = () => {
		this.setState({sendToKioskModalOpen: !this.state.sendToKioskModalOpen});
	}

	handleToggleShowDLModal = (id) => {
		this.state.currID = id;
		this.setState({showDLmodal: !this.state.showDLmodal});
	}

	handleDLmodalSubmit = () => {
		this.handleToggleShowDLModal();
		this.reloadTable();
	}

	/**
	 * @param {Dispositions_Pendings_Object} object
	 * @returns {function(): void}
	 */
	handleSendToKioskClick = (object) => () => {
		this.setState({
			id: object.pending,
			binary_id: object.pending_binary_id
		});

		this.handleToggleSendToKioskModal();
	}

	handleAfterKiosk = () => {
		this.setState({
			id: null,
			binary_id: null,
			object: null
		});
		this.props.reloadPage();
	}

	handleDeletePending = async (e) => {
		this.model.object.pkey = parseInt(e.currentTarget.id);
		this.model.object.binary_id = e.currentTarget.getAttribute('binary_id');
		confirmAlert({
			title: 'Confirm Delete',
			message: 'Are you sure you want to delete this Pending 4473?',
			buttons: [
				{
					label: 'Yes',
					color: 'danger',
					onClick: async () => {
					try {
						await this.model.submit(null, "DELETE");
						this.reloadTable();
					} catch (error) {
					}
					this.model.object.pkey = '';
					this.model.object.binary_id = '';
					this.props.reloadPage();
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	};

	render() {
		const {data, pages, limit, loading} = this.state;
		let today = moment().local().format("MM/DD/YYYY");
		const columns = [
			{
				Header: "Kiosk",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 130,
				/** @param {Dispositions_Pendings_Object} props.original */
				Cell: props => {
					let requires_resign = props.original.signature_14_date && moment(props.original.signature_14_date).local().format("MM/DD/YYYY") !== today
						&& (!props.original.signature_22_date || moment(props.original.signature_22_date).local().format("MM/DD/YYYY") !== today);
					return (
						<Button color="green-meadow" size={"sm"} block={true}
						        onClick={this.handleSendToKioskClick(props.original)}>
							<i className={"fa fa-arrow-left"}/> {requires_resign ? ' Line 30 Required' : ' Send to Kiosk'}
						</Button>
					);
				}
			},
			{

				Header: "Review",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 130,
				/** @param {Dispositions_Pendings_Object} props.original */
				Cell: props => {
					let requires_resign = props.original.signature_14_date && moment(props.original.signature_14_date).local().format("MM/DD/YYYY") !== today
						&& (!props.original.signature_22_date || moment(props.original.signature_22_date).local().format("MM/DD/YYYY") !== today);
					if (props.original.partial) {
						return <div style={{textAlign: 'center', marginTop: '2px'}}>Blank 4473</div>
					}
					// if (!props.original.customer_completed) {
					// 	return <div style={{textAlign: 'center', marginTop: '2px'}}>Missing Section B</div>
					// }
					return <Link
						to={requires_resign ? ('/dispositions/pendings/' + props.original.pending_binary_id + '-' + props.original.pending) : ('/dispositions/one_page/' + props.original.pending_binary_id + '-' + props.original.pending)}>
						<Button
							color={requires_resign ? "warning" : 'blue-hoki'} size={"sm"} block={true} data-cy={`edit-${props.original.name_first+props.original.name_last}`}>
							{requires_resign ? 'Reopen ' : 'Review '}4473 <i className={"fa fa-arrow-right"}/>
						</Button>
					</Link>
				}
			},

			{
				Header: "ID",
				id: "pending",
				sortable: true,
				width: 120,
				/** @param {Dispositions_Pendings_Object} obj */
				accessor: obj => obj.pending_binary_id + '-' + obj.pending
			},
			{
				Header: "Date",
				id: "date",
				width: 100,
				/** @param {Dispositions_Pendings_Object} obj */
				accessor: obj => obj.date ? moment(obj.date).local().format("MM/DD/YYYY") : ''
			},

			{
				Header: "Name",
				id: "name_first",
				/** @param {Dispositions_Pendings_Object} obj */
				accessor: obj => obj.name_first + ' ' + (obj.name_middle === 'NMN' ? '' : obj.name_middle + ' ') + obj.name_last
			},

			{
				Header: "Address",
				id: "disposition_pendings.street_1",
				/** @param {Dispositions_Pendings_Object} obj */
				accessor: obj => (obj.street_1 + " " + (obj.street_2 ? obj.street_2 + " " : "") + obj.city + ", " + obj.state + " " + obj.zip)
			},

			{
				Header: "Product",
				id: "product",
				sortable: false,
				/** @param {Dispositions_Pendings_Object|Products_Object} obj */
				accessor: obj => obj.serial_number ? (obj.type + ' | ' + (obj.manufacturers ? obj.manufacturers.name : obj.manufacturer_other) + ' | ' + obj.model + ' | ' + obj.serial_number) : ''
			},
			{
				Header: "Location",
				id: "location",
				/** @param {Dispositions_Pendings_Object|Products_Object} obj */
				accessor: obj => obj.locations ? (obj.locations.name_display || obj.locations.name) : ''
			},

			{
				Header: "Birth Date",
				id: "birth_date",
				width: 100,
				/** @param {Dispositions_Pendings_Object} obj */
				accessor: obj => {
					return obj.birth_date ? moment(obj.birth_date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "Digitally Signed",
				id: "signed",
				width: 100,
				/** @param {Dispositions_Pendings_Object} obj */
				accessor: obj => obj.signature_22_date ? (moment(obj.signature_22_date).local().format("MM/DD/YYYY")) : (obj.signature_14_date ? (moment(obj.signature_14_date).local().format("MM/DD/YYYY")) : 'Not Signed')
			},
			{
				Header: "Status",
				id: "status",
				width: 130,
				/** @param {Dispositions_Pendings_Object} obj */
				accessor: obj => obj.nics_response === 'Delayed' ? 'Delayed' : (obj.paused === true ? 'Paused' :
					(!obj.customer_completed ? 'Awaiting Section B' : 'Pending'))
			},
			{

				Header: "DL Scan",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 130,
				/** @param {Dispositions_Pendings_Object} props.original */
				Cell: props => {
					return (
						<Button
							onClick={() => this.handleToggleShowDLModal(props.original.pending_binary_id + '-' + props.original.pending)}
							color={'blue-hoki'} size={"sm"} block={true}>
							<i className={"fa fa-automobile"}/> DL Scan
						</Button>
					)}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						props.original.name_last === '' && props.original.name_first === '' ?
							<Tooltip title={"Delete Pending"}>
							<Button
								id={props.original.pending}
								binary_id={props.original.pending_binary_id}
								color="danger"
								size={"sm"}
								block={true}
								onClick={this.handleDeletePending}>
								<i className={"fa fa-times-circle"}/>
							</Button>
						</Tooltip> : ''
					);
				}
			},
			// {
			// 	Header: "",
			// 	className: "button-cell",
			// 	filterable: false,
			// 	sortable: false,
			// 	width: 40,
			// 	/** @param {Dispositions_Pendings_Object} props.original */
			// 	Cell: props => <Button color="danger" size={"sm"} block={true}
			// 		                 onClick={this.handleDelete(props.original.pending, props.original.pending_binary_id)}><i
			// 			className={"fa fa-trash"}/></Button>
			// },
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Pending Firearms on 4473s', "")}
							{this.renderLocationFilter()}
							{this.renderHeaderRight("Pending Firearms on 4473s", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<UniversalModalOverride
						locations={this.props.locations}
						kiosks={this.props.kiosks}
						states={this.props.states}
						history={this.props.history}
						id={this.state.id}
						binary_id={this.state.binary_id}
						name={"Send to Kiosk"}
						object={Objects.SendToKiosk}
						/*objectProps={{
							object: this.state.object
						}}*/
						showModal={this.state.sendToKioskModalOpen}
						handleToggle={this.handleToggleSendToKioskModal}
						afterSave={this.handleAfterKiosk}
						hideGoTo={true}
					/>

					<UniversalModalOverride
						locations={this.props.locations}
						kiosks={this.props.kiosks}
						states={this.props.states}
						history={this.props.history}
						id={this.state.currID}
						binary_id={this.state.binary_id}
						title={"Waiting for Drivers License Barcode Scan"}
						objectProps={{
							mytoggle: this.handleDLmodalSubmit
						}}
						object={Objects.DriversLicenseScan}
						showModal={this.state.showDLmodal}
						handleToggle={this.handleToggleShowDLModal}
						afterSave={this.handleAfterSave}
						hideGoTo={true}
						cancelLabel={"Close"}
						submitLabel={"Save"}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
